import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/usen_logo.svg'
import _imports_1 from '@/assets/images/icon_facebook.svg'


const _hoisted_1 = { class: "sitemap" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "contents" }
const _hoisted_4 = { class: "menu" }
const _hoisted_5 = { class: "page" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "company" }
const _hoisted_8 = { class: "dim" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "services" }
const _hoisted_11 = { class: "list" }
const _hoisted_12 = {
  key: 0,
  class: "category-title"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = {
  key: 1,
  class: "category-title"
}
const _hoisted_15 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"header\" data-v-675e663f><div class=\"logo\" data-v-675e663f><img src=\"" + _imports_0 + "\" data-v-675e663f></div><div class=\"facebook\" data-v-675e663f><a href=\"https://www.facebook.com/USEN.corp\" target=\"_blank\" data-v-675e663f><img src=\"" + _imports_1 + "\" data-v-675e663f> Facebook </a></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
              return (_openBlock(), _createElementBlock("li", {
                key: page.title,
                class: _normalizeClass({ 'add-margin': page.margin })
              }, [
                _createElementVNode("a", {
                  href: page.link
                }, _toDisplayString(page.title), 9, _hoisted_6)
              ], 2))
            }), 128))
          ]),
          _createElementVNode("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (category) => {
              return (_openBlock(), _createElementBlock("li", {
                key: category.title
              }, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(category.title), 1),
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.children, (company) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: company.title
                    }, [
                      _createElementVNode("a", {
                        href: company.link
                      }, _toDisplayString(company.title), 9, _hoisted_9)
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[0] || (_cache[0] = _createStaticVNode("<p class=\"dim\" data-v-675e663f>業種別サービス一覧</p><div class=\"header\" data-v-675e663f><p data-v-675e663f>USENのサービス一覧</p><ul data-v-675e663f><li data-v-675e663f><a href=\"https://usen.com/service/busi_type/restaurant.html\" target=\"_blank\" data-v-675e663f>飲食店</a></li><li data-v-675e663f><a href=\"https://usen.com/service/busi_type/beautysalons.html\" target=\"_blank\" data-v-675e663f>理美容</a></li><li data-v-675e663f><a href=\"https://usen.com/service/busi_type/store.html\" target=\"_blank\" data-v-675e663f>小売店</a></li><li data-v-675e663f><a href=\"https://usen.com/service/busi_type/office.html\" target=\"_blank\" data-v-675e663f>オフィス</a></li><li data-v-675e663f><a href=\"https://usen.com/service/busi_type/hospital.html\" target=\"_blank\" data-v-675e663f>病院</a></li><li data-v-675e663f><a href=\"https://usen.com/service/busi_type/hotel.html\" target=\"_blank\" data-v-675e663f>ホテル</a></li></ul></div>", 2)),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (col, index) => {
              return (_openBlock(), _createElementBlock("ul", { key: index }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col, (category) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: category.title
                  }, [
                    (category.link)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                          _createElementVNode("a", {
                            href: category.link,
                            target: "_blank"
                          }, _toDisplayString(category.title), 9, _hoisted_13)
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(category.title), 1)),
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.children, (service) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: service.title
                        }, [
                          _createElementVNode("a", {
                            href: service.link,
                            target: "_blank"
                          }, _toDisplayString(service.title), 9, _hoisted_15)
                        ]))
                      }), 128))
                    ])
                  ]))
                }), 128))
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}